export default "__VITE_ASSET__a9c95e1d__"